import React from 'react';
import '../css/Vodafonetree.css';
import { VodafoneTreeTypes } from '../Types/SummarypageTypes';
import { entities, subCategory } from '../css/Vodafonetree';

const Vodafonetree = ({
  tree,
  contentfuldata,
  recommendation,
}: VodafoneTreeTypes) => {
  let subCategoryCss, entitiesCss;
  if (tree && tree.subcategory.length >= 5) {
    subCategoryCss = subCategory;
    entitiesCss = entities;
  }

  const getRecommendation = (nodeName: string) => {
    const title = recommendation
      .map((item: any) => item.title)
      .indexOf(nodeName);
    const recommendationTab = document.getElementsByClassName(
      'tabs__tab'
    ) as HTMLCollectionOf<HTMLElement>;
    if (title >= 0) {
      return (
        <li className="view-recom">
          <span>
            <a
              href="#viewrecommendation"
              onClick={() => {
                recommendationTab[title].click();
              }}
            >
              {contentfuldata.viewRecommText}
              <img
                className="arrow-recom"
                src={contentfuldata.summaryPageIcons.rightArrowIcon.file.url}
              ></img>
            </a>
          </span>
        </li>
      );
    }
    return null;
  };

  return (
    <div className="spring">
      <div data-testid="containerTree" className="containerTree">
        <div className="new-tree">
          <div className="voda-Tree">
            <ul className="category">
              {tree &&
                tree.category.length > 0 &&
                tree.category.map((item: any, index: number) => (
                  <li key={index} className="li">
                    <span
                      className={
                        'dot ' + (item.type === 'available' ? 'dotactive' : '')
                      }
                    ></span>
                    <span
                      className={
                        'line ' +
                        (item.type === 'available' ? 'lineactive' : '')
                      }
                    ></span>
                    <span
                      className={
                        'nodeName ' +
                        (item.type === 'available' ? 'nodeactive' : '')
                      }
                    >
                      {item.nodeName}
                    </span>
                  </li>
                ))}
            </ul>
            <ul className="sub-category" css={subCategoryCss}>
              {tree &&
                tree.subcategory.length > 0 &&
                tree.subcategory.map((item: any, index: number) => (
                  <li key={index} className="li">
                    <span
                      className={
                        'dot ' + (item.type === 'available' ? 'dotactive' : '')
                      }
                    ></span>
                    <span
                      className={
                        'line ' +
                        (item.type === 'available' ? 'lineactive ' : '') +
                        (tree.subcategory.length >= 5 ? 'five' : '')
                      }
                    ></span>
                    <span
                      className={
                        'nodeName ' +
                        (item.type === 'available' ? 'nodeactive' : '')
                      }
                    >
                      {item.nodeName}
                    </span>
                  </li>
                ))}
            </ul>
            <ul className="entities" css={entitiesCss}>
              {tree &&
                tree.entities.length > 0 &&
                tree.entities.map((item: any, index: number) => (
                  <li key={index} className="li">
                    <span className="dot dotactive"></span>
                    <span className="nodeName nodeactive">
                      {item.maturitypercent.toString() + '%'}
                    </span>
                    <span className="entityName">{item.nodeName}</span>
                    <ul className="recom">
                      {item?.attributes?.length > 0 &&
                        item.attributes.map(
                          (attribute: any, attrnum: number) => (
                            <li key={attrnum}>
                              <img
                                src={
                                  attribute.type === 'missing'
                                    ? contentfuldata.summaryPageIcons
                                        .improvementIcon.file.url
                                    : contentfuldata.summaryPageIcons
                                        .strengthIcon.file.url
                                }
                              ></img>
                              <span className="nodeText3">
                                {attribute.nodeName}
                              </span>
                            </li>
                          )
                        )}
                      {getRecommendation(item.nodeName)}
                    </ul>
                  </li>
                ))}
            </ul>
            <div className="mobile-treeview">
              <ul className="mt-ul">
                <li>
                  <ul className="mt-ul">
                    {tree &&
                      tree.entities.length > 0 &&
                      tree.entities.map((item: any, index: number) => (
                        <li key={index} className="mtul-li">
                          <div className="mobile-treeview__level">
                            <div className="mobile-entity">
                              <div className="mobile-nodeName">
                                {item.maturitypercent.toString() + '%'}
                              </div>
                              <div className="mobile-entity-name">
                                {item.nodeName}
                              </div>
                            </div>
                            {item?.attributes?.length > 0 && (
                              <div className="recom-mobile">
                                {item.attributes.map(
                                  (attribute: any, attrnum: number) => (
                                    <div
                                      key={attrnum}
                                      className="nodeText3"
                                      style={{ display: 'flex' }}
                                    >
                                      <img
                                        className="recom-missingicon"
                                        src={
                                          attribute.type === 'missing'
                                            ? contentfuldata.summaryPageIcons
                                                .improvementIcon.file.url
                                            : contentfuldata.summaryPageIcons
                                                .strengthIcon.file.url
                                        }
                                      ></img>
                                      <span>{attribute.nodeName}</span>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            <div className="mobile-view-recom">
                              {getRecommendation(item.nodeName)}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vodafonetree;
